module.exports = __webpack_public_path__ + "img/hr-brown-asterisk-15.9fa6dc46.png";